import { Components, Theme } from "@mui/material";

declare module "@mui/material/IconButton" {}

export const MuiIconButton: Components<Theme>["MuiIconButton"] = {
  styleOverrides: {
    root: {
      width: "36px",
      height: "36px",
      borderRadius: "5px",
    },
  },
};
